import { render } from "./backGround.vue?vue&type=template&id=e38f590a"
import script from "./backGround.vue?vue&type=script&lang=js"
export * from "./backGround.vue?vue&type=script&lang=js"

import "./backGround.vue?vue&type=style&index=0&id=e38f590a&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__